import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.less'],

})
export class LoadingBarComponent implements OnInit {

  constructor() { }
  @Input()
  public progress: number = 0;
  ngOnInit(): void {
  }

}
